import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import SearchPrompt from './components/SearchPrompt.jsx';
import LoginPage from './components/LoginPage.jsx';
import SignupPage from './components/SignupPage.jsx';
import SignupSuccess from './components/SignupSuccess.jsx';
import Profile from './components/Profile.jsx';
import OAuthCallback from './components/OAuthCallback.jsx';
import PrivacyPage from './components/PrivacyPage.jsx';
import TermsPage from './components/TermsPage.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { AuthProvider } from './components/AuthContext.jsx';
import { NotificationProvider } from './components/NotificationContext.jsx';
import DynamicFooterTicker from './components/DynamicFooterTicker.jsx';
import UiDiscoveryLab from './components/uiLab/UiDiscoveryLab.jsx';
import { initPWA } from './pwa';
import { initSentry, captureException } from './utils/sentry';
import './styles/tokens.css';
import './styles/styles.css';

initSentry();

const App = () => (
  <ErrorBoundary onError={captureException}>
    <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route path="/" element={<SearchPrompt />} />
          <Route path="/ui-lab" element={<UiDiscoveryLab />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signup-success" element={<SignupSuccess />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/oauth/success" element={<OAuthCallback />} />
          <Route path="/oauth/error" element={<OAuthCallback />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="*" element={<SearchPrompt />} />
        </Routes>
        <DynamicFooterTicker />
      </NotificationProvider>
    </AuthProvider>
  </ErrorBoundary>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

initPWA();
